import { StrictMode } from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import { App } from './App';
import './styles/index.css';

const container = document.getElementById('root');

if (container) {
  const app = (
    <StrictMode>
      <App />
    </StrictMode>
  );

  // Production is prerendered and must be hydrated. Vite's development HTML
  // contains only the <!--app-html--> template marker, so there is no server
  // tree to hydrate and React must perform a normal client render instead.
  if (container.childElementCount > 0) hydrateRoot(container, app);
  else createRoot(container).render(app);
}
